import React from 'react'
import PPVTemplate from 'src/components/page/ppv'
import { promoCodes } from 'src/constants'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <PPVTemplate
        lang="en"
        market="us"
        location={props.location}
        title="Wilder vs Herndon"
        subtitle={`Watch live this Friday, June 27, on pay per view with Fubo`}
        video={'https://assets.fubo.tv/marketing/lp/videos/compressed/PPV_GCC_LP_6s_16x9.mp4'}
        videoMobile={'https://assets.fubo.tv/marketing/lp/videos/mobile/PPV_GCC_LP_6s_1x1.mp4'}
        offerCode={promoCodes.ppv_wilder_vs_herndon}
        isEventEnded={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 660px;
  }
`
